import { Field, TextInput } from '@kontentino/ui';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  defaultValues: FormState;
  onChange(params: FormState): void;
  disabled?: boolean;
};

type FormState = {
  url: string;
  title: string;
};

const PostComposerContentPinterestLinkForm: FC<Props> = (props) => {
  const { register, handleSubmit } = useForm<FormState>({
    defaultValues: props.defaultValues,
  });

  return (
    <form
      className="tw-flex tw-flex-col tw-gap-4"
      onBlur={handleSubmit(props.onChange)}
    >
      <Field.Group>
        <Field.Label required>Target Link</Field.Label>
        <TextInput {...register('url')} disabled={props.disabled} />
      </Field.Group>
      <Field.Group>
        <Field.Label required>Title</Field.Label>
        <TextInput {...register('title')} disabled={props.disabled} />
      </Field.Group>
    </form>
  );
};

export default PostComposerContentPinterestLinkForm;
